import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
// import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import FAQS from "../../../MyComponents/FooterPages/newfaq"
import heroContent from "../HeroContent-GDesign";
import leftimgs from "../../../assets/adobeleftimg.png";
import rightimgs from "../../../assets/adoberightimg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import FunActivities from "../../../MyComponents/FunActivities";
import BenefitsDataImg1 from "../../../assets/corel-benefit-img1.png";
import BenefitsDataImg2 from "../../../assets/corel-benefit-img2.png";
import BenefitsDataImg3 from "../../../assets/corel-benefit-img3.jpg";
import BenefitsDataImg4 from "../../../assets/corel-benefit-img4.png";
import BenefitsDataImg5 from "../../../assets/corel-benefit-img5.png";
import BenefitsDataImg6 from "../../../assets/corel-benefit-img6.png";
import BenefitsDataImg7 from "../../../assets/corel-benefit-img7.png";
import BenefitsDataImg8 from "../../../assets/BenefitsDataImg8.png";
import BenefitsDataImg9 from "../../../assets/corel-benefit-img9.png";
import FunactivitiesImg1 from "../../../assets/corelFun-img1.png";
import FunactivitiesImg2 from "../../../assets/corelFun-img2.png";
import FunactivitiesImg3 from "../../../assets/corelFun-img3.png";
import FunactivitiesImg4 from "../../../assets/corelFun-img4.png";
import FunactivitiesImg5 from "../../../assets/corelFun-img5.png";
import LearningStyle from "../../../MyComponents/LearningStyle"
import VideoSection from "../../../MyComponents/VideoSection";
import Testimonials from "../../../MyComponents/Testimonials";
import HeadSection from "../../HeadSection.js";
import pencilIcon from "../../../assets/pencil.png";
 const beginnerModules = [
    {
      title: "Module 1",
      activities: "09",
      classes: "07",
      description:"Introduction to Graphic Designing- Covers design principles, image sourcing, file formats, and online marketplaces for designers.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "07",
      description:"Corel Draw Basics- Introduces Corel Draw tools for shaping images, using text, connectors, and shadow effects.",
    },
    {
      title: "Module 2",
      activities: "09",
      classes: "09",
      description:"Corel Draw Advanced- Focuses on advanced tools for creating logos, visiting cards, certificates, and flex designs.",
    },
];    

  const benefitsData = [
      {
        title: "Design Basics",
        description: "Core graphic design concepts.",
        icon: "Polymath-images/corel-benefit-img1.png",
      },
      {
        title: "Elements & Principles",
        description: "Balance, contrast, alignment.",
        icon: "Polymath-images/corel-benefit-img2.png",
      },
      {
        title: "CorelDRAW Basics",
        description: "Navigate the interface and essential tools.",
        icon: "Polymath-images/corel-benefit-img3.jpg",
      },
      {
        title: "CorelDRAW Advanced",
        description: "Work with layers, vectors, and page layouts.",
        icon: "Polymath-images/corel-benefit-img4.png",
      },
      {
        title: "Color Tools",
        description: "Apply color theory and manage palettes efficiently",
        icon: "Polymath-images/corel-benefit-img5.png",
      },
      {
        title: "3D Tables",
        description: "Design detailed tables for print and digital",
        icon: "Polymath-images/corel-benefit-img6.png",
      },
      {
        title: "Object & Effects",
        description: "Add shadows, transparency, and special effects.",
        icon: "Polymath-images/corel-benefit-img7.png",
      },
      {
        title: "Logo Design",
        description: "Craft unique, scalable brand identities.",
        icon: "Polymath-images/BenefitsDataImg8.png",
      },
      {
        title: "Certificates & Flex",
        description: "Build impactful, print-ready documents.",
        icon: "Polymath-images/corel-benefit-img9.png",
      },
    ];
    const activitiesData = [
        {
          title: "Business Card",
          image: "Polymath-images/corelFun-img1.png",
        },
        {
          title: "Flyers",
          image: "Polymath-images/corelFun-img2.png",
        },
        {
          title: "Logos",
          image: "Polymath-images/corelFun-img3.png",
        },
        {
          title: "Book Covers",
          image: "Polymath-images/corelFun-img4.png",
        },
        {
          title: "Brochures",
          image: "Polymath-images/corelFun-img5.png",
        },
      ];
     const videoData = {
    title: "Watch Our Introduction Video",
    description:
      "Discover how kids can turn their creativity into stunning designs! In this video, we’ll introduce fun tools, basic design tips, and exciting projects like logos, flyers, and digital art. Whether you're just starting out or love being creative, this is the perfect place to begin your design journey.",

      
    videoSrc: "https://www.youtube.com/embed/p4pilMiPITE",
  };
const CorelDraw = () => {
  const Corelpage = heroContent.Corelsection;
  return (
    <>
       {/* <GuestNav/> */}
      <HeadSection
      leftImg={"Polymath-images/adobeleftimg.png"}
      rightImg={"Polymath-images/adoberightimg.png"}
      titlePart1="Corel Draw"
      titlePart2="Course"
      description="CorelDRAW is a Vector graphic software, allowing the user to produce outstanding Illustrations with millions of colours. To help kids deliver their message creatively and develop aesthetic sense, Polymath-Kids offers a Graphic Design with CorelDRAW course for kids age 9 and above. Kids will learn to pay attention to details, develop organizational and observational skills and create meaningful and impeccable designs."
      button1Text= {false}
      button2Text="Book Free Demo Class"
      button1Icon={"Polymath-images/pencil.png"}
      button2Icon={"Polymath-images/pencil.png"}
      onButton1Click={() => alert("Early bird discount clicked!")}
      onButton2Click={() => alert("Book demo clicked!")}
    />
       <CourseTimeline
        title="Course Structure and Syllabus"
        modules={beginnerModules}
      />
       <Benefits
        title="How Students Can Benefit From Abacus"
        benefitsData={benefitsData}
      />
       <FunActivities
              mainTitle="Learn Corel Draw"
              subTitle="With 40+ Fun Activities"
              activities={activitiesData}
            />
        <LearningStyle/>
         <VideoSection
        title={videoData.title}
        description={videoData.description}
        videoSrc={videoData.videoSrc}
      />
      <Testimonials/>
      <FAQS/>
       <Footer/>
    </>
  )
}
export default CorelDraw